import { zodResolver } from "@hookform/resolvers/zod";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import clsx from "clsx";
import ResponseMessage from "./ResponseMessage";
import { scrollToElement } from "../../utils/utils";
import "../styles/filedelement.scss";

const Form = ({
  defaultValues,
  children,
  onSubmit,
  validationSchema,
  className,
  successMsg,
  form
}) => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);

  // init react-hook-form
  const formMethods = useForm({
    defaultValues,
    resolver: zodResolver(validationSchema),
  });

  const { handleSubmit, formState, reset } = formMethods;

  useEffect(() => {
    // reset form and show success after onSubmit is run
    if (formState.isSubmitSuccessful) {
      reset();
      setShowSuccessMsg(true);
      const element = document.getElementById("form-success-msg");
      scrollToElement(element, 200);
      setTimeout(() => setShowSuccessMsg(false), 10000);
    }
  }, [formState, reset]);

  const onFormSubmit = async (data) => {
    await onSubmit(data);
  };

  return (
    <FormProvider {...formMethods}>
      <div id='form-success-msg'>
        {showSuccessMsg && (
          <ResponseMessage message={successMsg} type='success' />
        )}
      </div>
      <form
        ref={form}
        onSubmit={handleSubmit(onFormSubmit)}
        className={clsx("custom-form", className)}
        >
        {children}
      </form>
      {/* uncomment below for form state preview */}
      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
    </FormProvider>
  );
};

export default Form;
